module.exports = __webpack_public_path__ + "img/DNI-ALFY-Frente-Ejemplo.9191a8be.jpg";